
import { Component, Prop, mixins, Getter } from "nuxt-property-decorator"
import axios from "axios"
import Blocks from "~/mixins/blocks"
import { GET_LISTING } from "~/store/listing/getters"
import {
  ListingService,
  getV4ListingPayload,
  getV4Url,
  addPreListingIdToSessionStorage
} from "~/services/public/Listing"
import OldLocationInput from "~/components/generic/OldLocationInput.vue"
import OldPropertyInput from "~/components/generic/OldPropertyInput.vue"

@Component({
  components: { OldPropertyInput, OldLocationInput }
})
export default class HeaderLocationAndPropertyFormFormComponent extends mixins(Blocks) {
  @Prop({ type: Number }) categoryId: number
  @Prop({ required: true, type: Object }) block: Record<string, any>

  submittingForm: boolean = false
  trustpilotCustomers = "0"

  @Getter(GET_LISTING, { namespace: "listing" }) getListing: Listing | null

  async created() {
    const trustPilotConfig = this.$config.trustPilot
    const trustpilotURL = `https://api.trustpilot.com/v1/business-units/${trustPilotConfig.id}`

    try {
      const axiosInstance = axios.create() as any
      const response = await axiosInstance.get(trustpilotURL, {
        params: {
          apikey: trustPilotConfig.apiKey
        }
      })
      if (response.status === 200 && response.data) {
        this.trustpilotCustomers = Number(response.data.numberOfReviews.total).toLocaleString()
      }
    } catch (err) {
      console.log("Trustpilot error", err)
    }
  }

  async submitLocationAndPropertyForm() {
    if (this.submittingForm) return
    this.submittingForm = true
    try {
      const payload = getV4ListingPayload(this.getListing, this.categoryId)
      const listingService = new ListingService(this.$axios, this.$config)
      const response = await listingService.postPreListing(payload)

      if (response.data && response.data.pre_listing_id && response.data.category_id) {
        addPreListingIdToSessionStorage(response.data)
        window.location.href = getV4Url(this.$config.v4Host, response.data, payload)
        this.submittingForm = false
        return
      } else {
        this.submittingForm = false
      }
    } catch (err) {
      this.submittingForm = false
      console.log("PreListing creation error", err)
    }
  }

  get imageData() {
    const imageUrl = this.block.innerBlocks[0].attributes.find(
      attribute => attribute.name === "url"
    )

    const imageId = this.block.innerBlocks[0].attributes.find(attribute => attribute.name === "id")

    return { url: imageUrl.value, id: imageId.value }
  }

  get phoneElements() {
    if (typeof this.block.innerBlocks[1] === "undefined") {
      return null
    }

    const phoneHtml = this.block.innerBlocks[1].innerBlocks[0].innerHtml

    const phoneText = phoneHtml.replace(
      new RegExp('<h2 class="has-text-align-center"><a href[^>]*>+(.*)<\/a></h2>'),
      "$1"
    )

    const phoneHref = phoneHtml.replace(
      new RegExp('<h2 class="has-text-align-center"><a href="(.*)">+.*<\/a><\/h2>'),
      "$1"
    )

    return { phoneText, phoneHref }
  }
}
